import {
  getGlobalFilter,
  getMetainf,
  getProjectZoneId,
  getUsersColumns,
  getUsersEvent,
  getUsersFilter,
  isUsersAggregateEnabled,
} from '../reducers/analyticsApp';
import { toFilter } from './filterConverter';
import fromUsersResult from './usersConverter';
import { makeTableConfig } from '../utils/table';
import { toCsvUsers } from './csv/csvConverter';
import { getZoneId } from '../reducers/project';

const getDefaultGroupColumn = (eventName) => {
  switch (eventName) {
    case 'WAU':
      return 'WEEK';
    case 'MAU':
      return 'MONTH';
    default:
      return 'DAY';
  }
};

export const buildUsersQuery = (state) => {
  const eventName = getUsersEvent(state);
  const usersColumns = getUsersColumns(state).map((column) => column.value);
  const aggregate = isUsersAggregateEnabled(state);

  const fieldQuery = aggregate ? 'groupBy' : 'columns';
  return {
    eventName,
    aggregations: [],
    [fieldQuery]: ['event.user_id', getDefaultGroupColumn(eventName)].concat(usersColumns),
    filter: toFilter(getUsersFilter(state)),
    globalFilter: toFilter(getGlobalFilter(state)),
    timezone: getProjectZoneId(state),
  };
};

export const getUsersInfo = (state) => {
  const metainf = getMetainf(state);
  const zoneId = getZoneId(state);

  return { metainf, zoneId };
};

export const fromCsvUsersResponse = (response, query, usersInfo) => {
  const { metainf, zoneId } = usersInfo;
  const { result } = fromUsersResult(response, query);
  const { columns, rows } = result;
  const conf = makeTableConfig(metainf, { columns, rows }, zoneId);
  return toCsvUsers(conf);
};
